import { Component, h, Host, Listen, Element } from '@stencil/core';

@Component({
    tag: 'sew-ws-notifications',
    styleUrl: 'sew-ws-notifications.scss',
    shadow: true,
})
export class SewWsNotifications {
    @Element() el: HTMLSewWsNotificationsElement;

    private notficationsRef: HTMLElement;

    @Listen('addNotification')
    // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
    addNotification(event): void {
        this.calculateTopPosition();

        let notification = event.detail;

        if (!(notification instanceof HTMLElement)) {
            const element = document.createElement('sew-ws-notification');

            element.setAttribute('headline', notification.headline);
            element.setAttribute('message', notification.message);
            if (notification.duration) {
                element.setAttribute('duration', notification.duration);
            }
            element.innerHTML = notification.link;
            notification = element;
        }

        this.notficationsRef.appendChild(notification);
    }

    private calculateTopPosition() {
        const header = document.querySelector('sew-ws-header');
        const headerHeight = header ? header.offsetHeight : 0;

        this.el.style.setProperty('--header-height', headerHeight + 'px');
    }

    render() {
        return (
            <Host>
                <div ref={ref => (this.notficationsRef = ref)} />
            </Host>
        );
    }
}
